// actions
import {
  HEADER_UPDATE_TITLE,
  HEADER_UPDATE_BODY,
  HEADER_UPDATE_ALL,
} from './actions';

const Header = (state = {
  title: '',
  body: '',
}, action) => {
  switch (action.type) {
    case HEADER_UPDATE_TITLE:
      return {
        ...state,
        title: action.title,
      };
    case HEADER_UPDATE_BODY:
      return {
        ...state,
        body: action.body,
      };
    case HEADER_UPDATE_ALL:
      return {
        ...state,
        // TOOD: maybe make this more intuitive
        title: action.data.title,
        body: action.data.body,
      };
    default:
      return state;
  }
};

export default Header;
